import PinDashboard from "./PinDashboard";

const PinMessage = ({ msgId, setDashboards }) => {
  return (
    <div>
      <PinDashboard msgId={msgId} setDashboards={setDashboards} />
    </div>
  );
};

export default PinMessage;
